import { useTranslation } from 'react-i18next';

import { SocialCurrencyActiveIcon } from '@/components/SocialCurrencyActiveIcon';
import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useFormatCurrency } from '@/hooks/use-format-currency';
import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';
import { toLocaleCurrency } from '@/utils/numeric/currency';

interface PlaceBetButtonLabelProps {
    totalBetCount: number;
    totalStake: number;
    disabled: boolean;
}

export const PlaceBetButtonLabel = (props: PlaceBetButtonLabelProps) => {
    const isPredictions = useIsPredictionsProduct();
    return isPredictions ? <PredictionsButtonLabel {...props} /> : <SweepsButtonLabel {...props} />;
};

const PredictionsButtonLabel = ({
    totalStake,
    disabled,
}: Pick<PlaceBetButtonLabelProps, 'totalStake' | 'disabled'>) => {
    const { t } = useTranslation(['betslip_sbk']);

    return (
        <Text color={disabled ? 'neutral400' : ds.colorToken.text.primary} variant="titleMedium2">
            {`${t('place_trade')} • ${toLocaleCurrency(totalStake)}`}
        </Text>
    );
};

const SweepsButtonLabel = ({ totalBetCount, totalStake, disabled }: PlaceBetButtonLabelProps) => {
    const { t } = useTranslation(['betslip_sbk']);
    const { formatCurrency } = useFormatCurrency();

    const textColor = disabled ? 'neutral400' : ds.colorToken.text.primary;
    const label = totalBetCount > 1 ? t('place_entries_count', { count: totalBetCount }) : t('place_entry');

    return (
        <Row alignItems="center" gap="s6">
            <Text color={textColor} variant="titleMedium2">
                {label}
            </Text>
            <Text color={textColor} variant="titleMedium2">
                •
            </Text>
            <Row gap="s4" alignItems="center">
                <Box opacity={disabled ? 0.3 : 1}>
                    <SocialCurrencyActiveIcon />
                </Box>
                <Text color={textColor} variant="titleMedium2">
                    {formatCurrency(totalStake)}
                </Text>
            </Row>
        </Row>
    );
};
